var default_imagepreviewtext = '<p>Click to upload a new image.</p>';
var default_videopreviewtext = '<p>Click to upload a new image.</p>';

function activateSection($, id, force = false) {
   // scroll to top of page

  $('html, body').animate({
    scrollTop: 0
  }, 500);

  if (!force) {
    var allowedToNavigate = validateCurrentPage($);
  }

  // if we are on the last setion, always allow navigation
  var $currentPage = $('.form_page.active');
  if ($currentPage.length > 0) {
    var $nextPage = $currentPage.next('.form_page');
    if ($nextPage.length === 0) {
      allowedToNavigate = true;
    }
  }

  if (allowedToNavigate) {
    $('.form_page').hide();
    $('.form_page').removeClass('active');

    $('#' + id).show();
    $('#' + id).addClass('active');  

    var nav_link_selector = '#form_navigator_link_' + id;
    $('.form_navigator a').removeClass('active');
    $(nav_link_selector).addClass('active');

  }



}

function redrawForm($) {
    // if field #price_negotiable is checked, hide fixed price fields
    var fixedPriceSelected = $('#exhibition_details_price_price_fixed').is(':checked');
    var $negotiablePriceRadio = $('.sub_field_price .radio-group-exhibition_details_price_price').filter(function() {
      return $(this).find('input[value="negotiable"]').length > 0;
    }).first();
    var $fixedPriceFields = $('.sub_field_fixed_price_value, .sub_field_fixed_price_freight');
    

    clearTimeout(fixedPriceFieldRevealTimer);

    if (fixedPriceSelected) {
      $fixedPriceFields.hide();
      fixedPriceFieldRevealTimer = setTimeout(function() {
        if ($('#exhibition_details_price_price_fixed').is(':checked')) {
          $fixedPriceFields.show();
        }
      }, fixedPriceSlideDurationMs);
    } else {
      $fixedPriceFields.hide();
    }

    $negotiablePriceRadio.toggleClass('is-shifted-for-fixed-price', fixedPriceSelected);
    
    renumberImagesForms($);

    // if ($('#price_negotiable').is(':checked')) { {
    //   $('.sub_field_fixed_price_value').hide();
    //   $('.sub_field_fixed_price_freight').hide();
    // }
}

function renumberImagesForms($) {
  var exhibition_image_form_holder = $('.exhibition-image-form-holder');
  var current_image_forms = exhibition_image_form_holder.children('.exhibition-image-form');
  current_image_forms.each(function(index, element) {
    var newNum = index + 1;
    $(element).attr('data-num', newNum);
    $(element).find('.form_number').text(newNum);
    // work_1_artist_name
    // replace any instances of work_1_ with work_{newNum}_
    $(element).find('label').each(function(idx, el) {
      var forAttr = $(el).attr('for');
      if (forAttr) {
        var newForAttr = forAttr.replace(/work_\d+_/, 'work_' + newNum + '_');
        $(el).attr('for', newForAttr);
      };
    });

      $(element).find('input, select, textarea').each(function(idx, el) {
        var nameAttr = $(el).attr('name');
        if (nameAttr) {
          var newNameAttr = nameAttr.replace(/work_\d+_/, 'work_' + newNum + '_');
          $(el).attr('name', newNameAttr);
        }
      });

    });

}

function updateWorkMediaDetailLabels($form, mediaType) {
  var isVideo = mediaType === 'video' || $form.hasClass('has-media-video');
  var captionLabel = isVideo ? 'Video Caption' : 'Image Caption';
  var creditLabel = isVideo ? 'Video Credit' : 'Image Credits';

  $form.find('.field-group-image_caption > label').first().text(captionLabel);
  $form.find('.field-group-image_credits > label').first().text(creditLabel);
}

function updateAllWorkMediaDetailLabels($) {
  $('.exhibition-image-form-holder').children('.exhibition-image-form').each(function() {
    updateWorkMediaDetailLabels($(this));
  });
}

function rebuildImagesForm($) {

  var exhibition_image_form_holder = $('.exhibition-image-form-holder');
  var current_image_forms = exhibition_image_form_holder.children('.exhibition-image-form');
  var numExhibitionImages = current_image_forms.length;

  if (numExhibitionImages < 1) {
    exhibition_image_form_holder.append(imagesFormCopy.clone());
  }  

  // if less than 10 forms, show the add button on the last form
  current_image_forms = exhibition_image_form_holder.children('.exhibition-image-form');
  numExhibitionImages = current_image_forms.length;
  if (numExhibitionImages < 10) {
    var $lastform = current_image_forms.last();
    
    if ($lastform.hasClass('has-media') || $lastform.hasClass('select-media')) {
      exhibition_image_form_holder.append(imagesFormCopy.clone());
      current_image_forms = exhibition_image_form_holder.children('.exhibition-image-form');
      $lastform = current_image_forms.last();
      $lastform.find('.button-add-workmedia').show();
    }
  }

  renumberImagesForms($);
  syncAllWorkMediumOtherFields(exhibition_image_form_holder);
  updateAllWorkMediaDetailLabels($);

}

var numExhibitionImages = 1;
var imagesFormCopy = false;
var fixedPriceFieldRevealTimer = null;
var fixedPriceSlideDurationMs = 200;

function removeExhibitionImagesForm($form) {
  var num = $form.attr('data-num');
  
  $form.remove();
  recalcImageCount($);
  // give it a moment to remove, then rebuild the form list
  setTimeout(() => {
    rebuildImagesForm(jQuery);
  }, 1);

}

function recalcImageCount($){
  console.log('Recalculating image count');
  var exhibition_image_form_holder = $('.exhibition-image-form-holder');
  var current_image_forms = exhibition_image_form_holder.children('.exhibition-image-form');

  $sizeOfImages = 0;
  current_image_forms.each(function(index, element) {
    if ($(element).hasClass('has-media-image')) {
      var imgsize = parseFloat($(element).find('.exhibition_image_size').val());
      if (!isNaN(imgsize)) {
        $sizeOfImages += imgsize;
      }
    }
  });


  var sizeText = '';
  if ($sizeOfImages > 1024) {
    sizeText = ($sizeOfImages / 1024).toFixed(1) + ' MB';
  } else {
    sizeText = $sizeOfImages.toFixed(0) + ' KB';
  }
  var numImages = current_image_forms.filter('.has-media-image').length;
  var numVideos = current_image_forms.filter('.has-media-video').length;

  var imageCountText = numImages + ' image' + (numImages !== 1 ? 's' : '') + ' uploaded';
  if ($sizeOfImages > 0) {
    imageCountText += ', total ' + sizeText;
  }

  if (numVideos > 0) {
    imageCountText += '. ' + numVideos + ' video' + (numVideos !== 1 ? 's' : '') + ' added';
  }

  if ($sizeOfImages === 0 && numVideos === 0) {
    $('.image_count_holder').hide();
  } else {
    $('.image_count_holder').show();  
  }

  $('.image_count').text(imageCountText);
  
  // Clear validation error if at least one image or video has been added
  if (numImages > 0 || numVideos > 0) {
    var $imageFormHolder = $('.exhibition-image-form-holder');
    var $parentFormFieldGroup = $imageFormHolder.closest('.form-field-group');
    if ($parentFormFieldGroup.length > 0) {
      $parentFormFieldGroup.removeClass('validation_error validation_error_field-group_image_gallery');
    }
    // Also clear the page navigator error for this page
    var $imagePage = $imageFormHolder.closest('.form_page');
    if ($imagePage.length > 0) {
      var pageId = $imagePage.attr('id');
      if (pageId) {
        $('#form_navigator_link_' + pageId).removeClass('validation_error');
      }
    }
  }

}

function addNewExhibitionImagesForm($) {

  var exhibition_image_form_holder = $('.exhibition-image-form-holder');
  var current_image_forms = exhibition_image_form_holder.children('.exhibition-image-form');

  var lastForm = current_image_forms.last();
  // are the 'add' buttons visible on the last form?
  var addButtonsVisible = lastForm.find('.button-add-workmedia').is(':visible');
  if (addButtonsVisible)  {
      return;
  }
  
  var numExhibitionImages = current_image_forms.length;


  var numFormsToShow = numExhibitionImages + 1;
  var maxForms = 10;
  if (numFormsToShow > maxForms) {
    numFormsToShow = maxForms;
  }
  for (var i = 1; i <= numFormsToShow; i++) {
    if (i > current_image_forms.length) {
      var newForm = imagesFormCopy ? imagesFormCopy.clone() : current_image_forms.first().clone();
      newForm.attr('data-num', i);
      newForm.attr('class', 'exhibition-image-form');



      
      // clear the input fields
      newForm.find('input, select, textarea').each(function(index, element) {
        var type = $(element).attr('type');
        if (type === 'button') {
          // do nothing
        }
        else if (type === 'checkbox' || type === 'radio') {
          $(element).prop('checked', false);
        }
        else {
          $(element).val('');
        }
      }
      );
      newForm.find('.form_number').text(i);
      newForm.find('.exhibition_image_preview').html(default_imagepreviewtext);
      newForm.find('.exhibition_video_preview').html(default_videopreviewtext);
      newForm.find('.wysiwyg-editor').html('');
      newForm.find('.wysiwyg-source').val('');
      newForm.find('.workmedia-details-filedetails').html('');
      updateWorkMediaDetailLabels(newForm, 'image');

      newForm.find('.exhibition_video_preview_container').hide();
      newForm.find('.add-workmedia-form').hide();
      newForm.find('.button-remove-workmedia-image').hide();
      newForm.find('.button-remove-workmedia-video').hide();
      newForm.find('.button-remove-workmedia-image').hide();
      if (i <= maxForms) {
        newForm.find('.button-add-workmedia').show();
      }

      // update the labels and ids
      newForm.find('label').each(function(index, element) {
        var forAttr = $(element).attr('for');
        if (forAttr) {
          var newForAttr = forAttr.replace(/\d+$/, i);
          $(element).attr('for', newForAttr);
        }
      });

      exhibition_image_form_holder.append(newForm);
    }
  };

  renumberImagesForms($);
  syncAllWorkMediumOtherFields(exhibition_image_form_holder);
  updateAllWorkMediaDetailLabels($);
}

function createSingleFileList(file) {
  if (typeof DataTransfer === 'undefined') {
    return null;
  }

  var dataTransfer = new DataTransfer();
  dataTransfer.items.add(file);
  return dataTransfer.files;
}

function isAcceptedImageFile(file) {
  if (!file) {
    return false;
  }

  if (typeof file.type === 'string' && file.type.indexOf('image/') === 0) {
    return true;
  }

  return /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(file.name || '');
}

function getAcceptedImageFiles(fileList) {
  return Array.from(fileList || []).filter(function(file) {
    return isAcceptedImageFile(file);
  });
}

function populateExhibitionImageFormFromFile($, $form, file) {
  var fileInput = $form.find('.exhibition_image_upload').get(0);
  var singleFileList = createSingleFileList(file);
  var sizeInKb = file.size / 1024;
  var displaySize = '';
  var filename = file.name || '';

  if (fileInput && singleFileList) {
    fileInput.files = singleFileList;
  }

  if (sizeInKb > 1024) {
    displaySize = (sizeInKb / 1024).toFixed(0) + ' MB';
  } else {
    displaySize = sizeInKb.toFixed(0) + ' KB';
  }

  filename = filename.substring(filename.lastIndexOf('/') + 1);
  filename = filename + ' (' + displaySize + ')';

  $form.find('.exhibition_image_size').val(sizeInKb);
  $form.find('.workmedia-details-filedetails').html(filename);
  $form.find('.add-workmedia-form.add-image-form').css('display', 'inline-block');
  $form.find('.add-workmedia-form.add-video-form').hide();
  $form.find('.exhibition_video_url, .exhibition_video_thumb_url').val('');
  $form.find('.exhibition_video_preview').html('');
  $form.find('.exhibition_video_preview_container').hide();
  $form.find('.button-expand').hide();
  $form.find('.button-remove-workmedia-image').show();
  $form.find('.button-remove-workmedia-video').hide();
  $form.removeClass('select-media has-media-video').addClass('has-media has-media-image');
  updateWorkMediaDetailLabels($form, 'image');

  var reader = new FileReader();
  reader.onload = function(e) {
    $form.find('.exhibition_image_preview').html('<img src="' + e.target.result + '" alt="Exhibition Image Preview" />');
    $form.find('.exhibition_image_preview_container').show();
  };
  reader.readAsDataURL(file);
}

function getBlankExhibitionImageForm($) {
  addNewExhibitionImagesForm($);

  return $('.exhibition-image-form-holder').children('.exhibition-image-form').filter(function() {
    return !$(this).hasClass('has-media') && !$(this).hasClass('select-media');
  }).last();
}

function handleSelectedExhibitionImageFiles($, $parentForm, files) {
  var maxForms = 10;
  var $holder = $('.exhibition-image-form-holder');
  var currentMediaCount = $holder.children('.exhibition-image-form').filter('.has-media').length;
  var currentFormAlreadyFilled = $parentForm.hasClass('has-media');
  var availableSlots = maxForms - currentMediaCount + (currentFormAlreadyFilled ? 1 : 0);
  var filesToUse = files.slice(0, availableSlots);

  if (filesToUse.length === 0) {
    return;
  }

  populateExhibitionImageFormFromFile($, $parentForm, filesToUse[0]);

  filesToUse.slice(1).forEach(function(file) {
    var $blankForm = getBlankExhibitionImageForm($);

    if ($blankForm.length === 0) {
      return;
    }

    populateExhibitionImageFormFromFile($, $blankForm, file);
  });

  addNewExhibitionImagesForm($);
  recalcImageCount($);
}

function syncWorkMediumOtherField($scope) {
  var $detailsForm = $scope.hasClass('add-workmediadetails-form') ? $scope : $scope.find('.add-workmediadetails-form').first();

  if ($detailsForm.length === 0) {
    return;
  }

  var $otherInput = $detailsForm.find('input[name$="_workmedium_other"]').first();

  if ($otherInput.length === 0) {
    return;
  }

  var $otherField = $otherInput.closest('.form-field-group');
  var $mediumOther = $detailsForm.find('input[type="checkbox"][name$="_workmedium[]"][value="other"]').first();
  var showOtherField = $mediumOther.length > 0 && $mediumOther.is(':checked');

  if (showOtherField) {
    $otherField.show();
    $otherInput.addClass('validate validation_required');
    return;
  }

  $otherField.hide();
  $otherInput.val('').removeClass('validation_required');
  $otherField.removeClass('validation_error');
}

function syncAllWorkMediumOtherFields($scope) {
  var $forms = $scope && $scope.length ? $scope.find('.add-workmediadetails-form') : jQuery('.add-workmediadetails-form');

  if ($scope && $scope.hasClass && $scope.hasClass('add-workmediadetails-form')) {
    $forms = $scope;
  }

  $forms.each(function() {
    syncWorkMediumOtherField(jQuery(this));
  });
}

function initTextareaCharacterCounter($, fieldId, counterClass) {
  var $field = $('#' + fieldId);

  if ($field.length === 0) {
    $field = $('textarea[name="' + fieldId + '"]');
  }

  if ($field.length === 0) {
    return;
  }

  var isWysiwyg = $field.is('[contenteditable]');
  var maxLength = parseInt($field.attr('maxlength'), 10) || parseInt($field.data('maxlength'), 10) || 800;
  var $counter = $('.' + counterClass);

  if ($counter.length === 0) {
    $counter = $('<p class="field-character-count ' + counterClass + '" aria-live="polite"><span class="char-current">0</span> / <span class="char-max">' + maxLength + '</span></p>');
    $field.after($counter);
  }

  var $current = $counter.find('.char-current');
  var $max = $counter.find('.char-max');
  $max.text(maxLength);

  var updateCount = function() {
    var value;
    if (isWysiwyg) {
      value = ($field[0] && $field[0].innerText) ? $field[0].innerText : '';
    } else {
      value = $field.val() || '';
      if (value.length > maxLength) {
        value = value.substring(0, maxLength);
        $field.val(value);
      }
    }
    $current.text(value.length);
    $counter.toggleClass('over-limit', value.length > maxLength);
  };

  $field.on('input keyup paste', updateCount);
  updateCount();
}

function syncWysiwygEditors() {
  document.querySelectorAll('.wysiwyg-editor-wrap').forEach(function(wrap) {
    var editor = wrap.querySelector('.wysiwyg-editor');
    var source = wrap.querySelector('.wysiwyg-source');
    if (editor && source) {
      source.value = editor.innerHTML;
    }
  });
}

function initWysiwygEditors($) {
  function updateToolbarStateForEditor(editorEl) {
    var $allButtons = $('.wysiwyg-btn[data-command]');

    // Reset all toolbars first so button state doesn't bleed across editors.
    $allButtons.removeClass('is-active');

    if (!editorEl) {
      return;
    }

    var $toolbarButtons = $(editorEl)
      .closest('.wysiwyg-editor-wrap')
      .find('.wysiwyg-btn[data-command]');

    $toolbarButtons.each(function() {
      $(this).toggleClass('is-active', !!document.queryCommandState($(this).data('command')));
    });
  }

  // Prevent toolbar clicks from blurring the editor.
  $(document).on('mousedown', '.wysiwyg-btn', function(e) {
    e.preventDefault();
  });

  // Execute formatting command when a toolbar button is clicked.
  $(document).on('click', '.wysiwyg-btn', function(e) {
    e.preventDefault();
    var cmd = $(this).data('command');
    document.execCommand(cmd, false, null);
    var $editor = $(this).closest('.wysiwyg-editor-wrap').find('.wysiwyg-editor');
    $editor.trigger('input').focus();
    updateToolbarStateForEditor($editor.get(0));
  });

  // Sync HTML → hidden textarea and trigger change for validation on every edit.
  $(document).on('input', '.wysiwyg-editor', function() {
    var $wrap = $(this).closest('.wysiwyg-editor-wrap');
    $wrap.find('.wysiwyg-source').val($(this)[0].innerHTML).trigger('change');
  });

  // Keep toolbar button active state in sync with cursor position.
  document.addEventListener('selectionchange', function() {
    var active = document.activeElement;
    if (!active || !active.classList.contains('wysiwyg-editor')) {
      updateToolbarStateForEditor(null);
      return;
    }
    updateToolbarStateForEditor(active);
  });
}

function initExhibitionDescriptionCounter($) {
  initTextareaCharacterCounter($, 'exhibition_details_exhibition_description', 'character-count-exhibition-description');
}

function initExhibitionAcknowledgementCounter($) {
  initTextareaCharacterCounter($, 'exhibition_details_exhibition_acknowledgement', 'character-count-exhibition-acknowledgement');
}

function initOtherMediaToggle($) {
  var $otherMediaField = $('.field-group-other_media');

  if ($otherMediaField.length === 0) {
    $otherMediaField = $('.form-field-group').filter(function() {
      return $(this).find('> label').first().text().trim().toLowerCase().indexOf('other media') === 0;
    }).first();
  }

  if ($otherMediaField.length === 0) {
    return;
  }

  var getMediumOtherCheckbox = function() {
    var $mediumOther = $('#exhibition_details_medium_other');

    if ($mediumOther.length === 0) {
      $mediumOther = $('input[type="checkbox"][name*="medium"][value="other"]').first();
    }

    if ($mediumOther.length === 0) {
      $mediumOther = $('input[type="checkbox"][name*="medium"]').filter(function() {
        var id = $(this).attr('id');
        if (!id) {
          return false;
        }
        return $('label[for="' + id + '"]').first().text().trim().toLowerCase() === 'other';
      }).first();
    }

    return $mediumOther;
  };

  var toggleOtherMediaField = function() {
    var $mediumOther = getMediumOtherCheckbox();
    var showOtherMedia = $mediumOther.length > 0 && $mediumOther.is(':checked');
    var $otherMediaInput = $('#exhibition_details_other_media');

    if (showOtherMedia) {
      $otherMediaField.show();
      if ($otherMediaInput.length > 0) {
        $otherMediaInput.addClass('validate validation_required');
      }
    } else {
      $otherMediaField.hide();
      $otherMediaField.find('input, select, textarea').val('');
      if ($otherMediaInput.length > 0) {
        $otherMediaInput.removeClass('validation_required');
        $otherMediaInput.closest('.form-field-group').removeClass('validation_error');
      }
    }
  };

  $otherMediaField.hide();
  $(document).on('change', 'input[type="checkbox"][name*="medium"]', toggleOtherMediaField);
  toggleOtherMediaField();
}

function initWorkMediumOtherToggle($) {
  syncAllWorkMediumOtherFields($('.exhibition-image-form-holder'));

  $('.exhibition-image-form-holder').on('change', 'input[type="checkbox"][name$="_workmedium[]"]', function() {
    syncWorkMediumOtherField($(this).closest('.add-workmediadetails-form'));
  });
}

function initOtherAccompanyingMaterialsToggle($) {
  var $otherMaterialsField = $('.field-group-other_exhibition_materials');

  if ($otherMaterialsField.length === 0) {
    return;
  }

  var $materialsOtherCheckbox = $('#exhibition_materials_accompanying_materials_other');
  var $otherMaterialsInput = $('#exhibition_materials_other_exhibition_materials');

  var toggleOtherMaterialsField = function() {
    var showOtherMaterials = $materialsOtherCheckbox.length > 0 && $materialsOtherCheckbox.is(':checked');

    if (showOtherMaterials) {
      $otherMaterialsField.show();
      if ($otherMaterialsInput.length > 0) {
        $otherMaterialsInput.addClass('validate validation_required');
      }
    } else {
      $otherMaterialsField.hide();
      $otherMaterialsField.find('input, select, textarea').val('');
      $otherMaterialsField.removeClass('validation_error');
      if ($otherMaterialsInput.length > 0) {
        $otherMaterialsInput.removeClass('validation_required');
        $otherMaterialsInput.closest('.form-field-group').removeClass('validation_error');
      }
    }
  };

  $otherMaterialsField.hide();
  $(document).on('change', '#exhibition_materials_accompanying_materials_other', toggleOtherMaterialsField);
  toggleOtherMaterialsField();
}

function initAddExhibition($) {

  if ($('.exhibition_submission_form').length > 0) {
    initMobileExhibitionFormSelects($);
    activateSection($, 'exhibition_details'); // exhibition_details
    redrawForm($);
    initExhibitionDescriptionCounter($);
    initExhibitionAcknowledgementCounter($);
    initTextareaCharacterCounter($, 'artists_curators_artists', 'character-count-artists');
    initTextareaCharacterCounter($, 'artists_curators_curators', 'character-count-curators');
    initOtherMediaToggle($);
    initWorkMediumOtherToggle($);
    initOtherAccompanyingMaterialsToggle($);
  initWysiwygEditors($);

  var exhibition_image_form_holder = $('.exhibition-image-form-holder');
  var current_image_forms = exhibition_image_form_holder.children('.exhibition-image-form');

  imagesFormCopy = current_image_forms.first().clone();
  updateAllWorkMediaDetailLabels($);


    $('.form_navigator a').on('click', function(e) {
      e.preventDefault();
      const target_id = $(this).attr('href').substring(1);
      activateSection($, target_id);
    });


    $('.button-previous-section').on('click', function(e) {
        e.preventDefault();
        if (validateCurrentPage($)) {
          const $currentPage = $(this).closest('.form_page');
          const $prevPage = $currentPage.prev('.form_page');
          if ($prevPage.length > 0) {
            const prevPageId = $prevPage.attr('id');
            activateSection($, prevPageId);
          }
        }
      }
    );

    $('.button-next-section').on('click', function(e) {
      e.preventDefault();

      if (validateCurrentPage($)) { 
        const $currentPage = $(this).closest('.form_page');
        const $nextPage = $currentPage.next('.form_page');
        if ($nextPage.length > 0) {
          const nextPageId = $nextPage.attr('id');
          activateSection($, nextPageId);
        }
      }
    });

    $('.button-submit-application').on('click', function(e) {
      e.preventDefault();
      submitExhibitionForm($);
    });
    
    $('.field-group-price').on('change', '.sub_field_price input[type="radio"], .sub_field_price input[type="checkbox"]', function() {
      redrawForm($);
    });

  $('.exhibition_submission_form').on('submit', function(e) {
      e.preventDefault();
      submitExhibitionForm($);
      return false;
    });
    
    $('.exhibition-image-form-holder').on('click', '.button-hidedetails', function(e) {
    
      e.preventDefault();
      var $parentForm = $(this).closest('.exhibition-image-form');
      var $detailsForm = $parentForm.find('.add-workmediadetails-form');

      if ($detailsForm.is(':visible')) {
        $detailsForm.slideUp();
        $(this).val('Show Details');
      } else {
        $detailsForm.slideDown();
        $(this).val('Hide Details');
      } 

    });

    $('.exhibition-image-form-holder').on('click', '.button-add-workmedia-image', function(e) {
      e.preventDefault();
      var $parentForm = $(this).closest('.exhibition-image-form');
      updateWorkMediaDetailLabels($parentForm, 'image');
      $parentForm.find(".add-workmedia-form.add-image-form").css('display', 'inline-block');
      $parentForm.find(".button-expand").hide();
      $parentForm.find(".button-remove-workmedia-image").show();
      $parentForm.addClass('select-media');
      $parentForm.find(".exhibition_image_upload").click();

    });

    
    $('.exhibition-image-form-holder').on('click', '.button-edit-workmedia-image', function(e) {
      e.preventDefault();
      var $parentForm = $(this).closest('.exhibition-image-form');
      updateWorkMediaDetailLabels($parentForm, 'image');
      $parentForm.find(".exhibition_image_upload").val('');
      $parentForm.find(".exhibition_image_preview").html('<p>Click to upload a new image.</p>');
      $parentForm.find(".workmedia-details-filedetails").html('');
      $parentForm.removeClass('has-media');
      $parentForm.addClass('select-media');
      $parentForm.find(".exhibition_image_upload").click();

    });

    $('.exhibition-image-form-holder').on('click', '.button-edit-workmedia-video', function(e) {
      e.preventDefault();
      var $parentForm = $(this).closest('.exhibition-image-form');
      updateWorkMediaDetailLabels($parentForm, 'video');
      $parentForm.find(".exhibition_video_url").val('');
      $parentForm.find(".exhibition_video_preview").html('');
      $parentForm.find(".workmedia-details-filedetails").html('');
      $parentForm.removeClass('has-media');
      $parentForm.removeClass('has-media-video');
      $parentForm.addClass('select-media');      
    });
    
    $('.exhibition-image-form-holder').on('click', '.button-remove-workmedia-image', function(e) {
        e.preventDefault();
      var $parentForm = $(this).closest('.exhibition-image-form');
        // clear the fields
        $parentForm.find('.add-workmedia-form.add-image-form').find('input, select, textarea').each(function(index, element) {
          $(element).val('');
        });
        $parentForm.find(".add-workmedia-form.add-image-form").hide();
        $parentForm.find(".button-expand").show();
        $parentForm.find(".button-remove-workmedia-image").hide();
        $parentForm.removeClass('has-media');
        $parentForm.removeClass('select-media');
        updateWorkMediaDetailLabels($parentForm, 'image');
        removeExhibitionImagesForm($parentForm);
      }
    );

    $('.exhibition-image-form-holder').on('click', '.exhibition_image_preview_container', function(e) {
      var $parentForm = $(this).closest('.exhibition-image-form');
      $parentForm.find(".exhibition_image_upload").click();
    });

    $('.exhibition-image-form-holder').on('click', '.button-remove-workmedia-video', function(e) {
        e.preventDefault();
        var $parentForm = $(this).closest('.exhibition-image-form');
        // clear the fields
        $parentForm.find('.add-workmedia-form.add-video-form').find('input, select, textarea').each(function(index, element) {
          $(element).val('');
        });
        $parentForm.find(".add-workmedia-form.add-video-form").hide();
        $parentForm.find(".button-expand").show();
        $parentForm.find(".button-remove-workmedia-video").hide();
        $parentForm.removeClass('has-media');
        $parentForm.removeClass('select-media');
        $parentForm.removeClass('has-media-video');
        updateWorkMediaDetailLabels($parentForm, 'image');

        removeExhibitionImagesForm($parentForm);
      }
    );

    $('.exhibition-image-form-holder').on('click', '.button-add-workmedia-video', function(e) {
      e.preventDefault();
      var $parentForm = $(this).closest('.exhibition-image-form');
      updateWorkMediaDetailLabels($parentForm, 'video');
      $parentForm.find(".add-workmedia-form.add-video-form").show();
      $parentForm.find(".button-expand").hide();
      $parentForm.find(".button-remove-workmedia-video").show();
      $parentForm.addClass('select-media');
      // if url contains localdev
      
    }
    );


    $('.exhibition-image-form-holder').on('change', '.exhibition_image_upload', function(e) {
      var $parentForm = $(this).closest('.exhibition-image-form');
      var input = this;
      var files = getAcceptedImageFiles(input.files || []);

      if (files.length > 0) {
        handleSelectedExhibitionImageFiles($, $parentForm, files);
      } else {
        $parentForm.find('.exhibition_image_preview').html('');
        $parentForm.find('.exhibition_image_preview_container').hide();
      } 

    });

    $('.exhibition-image-form-holder').on('click', '.button-add-video', function(e) {
      var $parentForm = $(this).closest('.exhibition-image-form');
      var $nextForm = $parentForm.next('.exhibition-image-form');
      $video_url = $parentForm.find('.exhibition_video_url').val();

      if ($video_url.length > 0 && validate_url($video_url)) {
        // YouTube video ID extraction and embed generation
        var video_id = '';
        var url_obj = new URL($video_url);
        var video_source = false;
        var youtube_hosts = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtu.be'];
        if (youtube_hosts.indexOf(url_obj.hostname) !== -1) {
          if (url_obj.hostname === 'youtu.be') {
            video_id = url_obj.pathname.split('/').filter(Boolean)[0] || '';
          } else if (url_obj.pathname.indexOf('/shorts/') === 0 || url_obj.pathname.indexOf('/embed/') === 0 || url_obj.pathname.indexOf('/live/') === 0) {
            video_id = url_obj.pathname.split('/').filter(Boolean)[1] || '';
          } else {
            video_id = url_obj.searchParams.get('v') || '';
          }
          video_source = 'youtube';
        } // do same for Vimeo
        else if (url_obj.hostname === 'vimeo.com' || url_obj.hostname === 'www.vimeo.com') {
          video_id = url_obj.pathname.substring(1);
          video_source = 'vimeo';
        }

        switch (video_source) {
          case 'youtube':
            var thumbnail_url = 'https://img.youtube.com/vi/' + video_id + '/0.jpg';
            $parentForm.find('.exhibition_video_thumb_url').val(thumbnail_url);

            $video_title = '';
            // YouTube oEmbed to get video title
            $.ajax({
              url: 'https://www.youtube.com/oembed?url=' + encodeURIComponent($video_url) + '&format=json',
              type: 'GET',
              dataType: 'json',
              async: false,
              success: function(data) {
                $video_title = data.title;
                $parentForm.find('.workmedia-details-filedetails').html($video_title);

              },
              error: function() {
                console.log('Error retrieving YouTube oEmbed data');
              }
            });


            break;
          case 'vimeo':
            // Vimeo thumbnail retrieval via oEmbed
            var thumbnail_url = '';
            $.ajax({
              url: 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent($video_url),
              type: 'GET',
              dataType: 'json',
              async: false,
              success: function(data) {
                thumbnail_url = data.thumbnail_url;
                var vimeo_title = data.title;
                $parentForm.find('.workmedia-details-filedetails').html(vimeo_title);
                $parentForm.find('.exhibition_video_thumb_url').val(thumbnail_url);
              },
              error: function() {
                console.log('Error retrieving Vimeo thumbnail');
              }
            });
            break;
          default:
            video_id = '';
        }

        if (video_id !== '') { 
          //var video_embed = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + video_id + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
          var video_thumbnail = '<img src="' + thumbnail_url + '" alt="Video Thumbnail" />';
          var thumbnail_with_link = '<a href="' + $video_url + '" target="_blank"><img src="' + thumbnail_url + '" alt="Video Thumbnail" /></a>';

          $parentForm.find('.exhibition_video_preview').html(thumbnail_with_link);
          $parentForm.find('.exhibition_video_preview_container').show();
          $nextForm.find('.button-add-workmedia').show();
          $parentForm.addClass('has-media');
          $parentForm.addClass('has-media-video');
          $parentForm.removeClass('has-media-image');
          $parentForm.removeClass('select-media');
          updateWorkMediaDetailLabels($parentForm, 'video');
          addNewExhibitionImagesForm($);
          recalcImageCount($);
        }
      } else {
        $parentForm.find('.exhibition_video_preview').html('');
        $parentForm.find('.exhibition_video_preview_container').hide();
      }
      
    });

    $('#exhibition_submission_form_testsubmit').on('click', function(e) {
        e.preventDefault();
        submitExhibitionForm($);
    });

    $('#exhibition_submission_form_fill').on('click', function(e) {
        e.preventDefault();
        // fill the form with test data
        $('.exhibition_submission_form').find('input, select, textarea').each(function(index, element) {
          var type = $(element).attr('type');
          var name = $(element).attr('name');
          if (type === 'button') {
            // do nothing
          }
          else if (type === 'file') {
            // do nothing
          }          
          else if (name === 'security') {
            // do nothing
          }          
          else if (name === 'exhibition_submission_form_submission_attempted') {
            // do nothing
          }          
          else if (name.includes('work_') && name.includes('_video_url')) {
            // do nothing
          }
          else if (name.includes('required_group')) {
            // do nothing
          }
          else if (name.includes('work_') && name.includes('_video_thumb_url')) {
            // do nothing
          }
          // if name contains 'url'
          else if (name.includes('url')) {
            // do nothing
            $(element).val('https://www.example.com/' + Math.floor(Math.random() * 10000));
          }
          else if (name.includes('email')) {
            $(element).val('ryan+' + Math.floor(Math.random() * 1000) + '@bitcraft.com.au');
          }
          else if (name.includes('exhibition_details_price_price')) {
            // Handled explicitly after the generic fill loop.
          }
          else if (type === 'checkbox' || type === 'radio') {
            if (Math.random() < 0.5) {
              $(element).prop('checked', true);
            }
          }
          else if (element.tagName === 'SELECT') {
            // select a random option
            var options = $(element).find('option');
            var randomIndex = 0;
            while (randomIndex === 0) {
              randomIndex = Math.floor(Math.random() * options.length);
            }
            $(element).val($(options[randomIndex]).val());

          }
          else {
            $(element).val('Test data for ' + name + ' ' + Math.floor(Math.random() * 1000));
            // send changed event to remove validation error
          }
            fieldChanged($, element);
        });

        // Fill contenteditable WYSIWYG editors as well (not included in input/select/textarea selector).
        $('.exhibition_submission_form').find('.wysiwyg-editor-wrap').each(function(index, wrap) {
          var $wrap = $(wrap);
          var $editor = $wrap.find('.wysiwyg-editor');
          var $source = $wrap.find('.wysiwyg-source');
          var sourceName = $source.attr('name') || ('wysiwyg_' + index);
          var testHtml = '<p><strong>Test data for ' + sourceName + '</strong></p><p><em>Generated sample content ' + Math.floor(Math.random() * 1000) + '</em></p><ul><li>Sample bullet one</li><li>Sample bullet two</li></ul>';

          $editor.html(testHtml).trigger('input');
          if ($source.length) {
            fieldChanged($, $source.get(0));
          }
        });

        // Explicitly choose either Fixed or Negotiable for the Exhibition price radio group.
        var chooseFixedPrice = Math.random() < 0.5;
        var $fixedPriceRadio = $('#exhibition_details_price_price_fixed');
        var $negotiablePriceRadio = $('#exhibition_details_price_price_negotiable');

        if ($fixedPriceRadio.length && $negotiablePriceRadio.length) {
          $fixedPriceRadio.prop('checked', chooseFixedPrice).trigger('change');
          $negotiablePriceRadio.prop('checked', !chooseFixedPrice).trigger('change');
          fieldChanged($, $fixedPriceRadio.get(0));
          fieldChanged($, $negotiablePriceRadio.get(0));
        }

        var $fixedPriceValueField = $('input[name="exhibition_details_price_fixed_price_value"], input[name="exhibition_details_price_fixed_price_value[]"]').first();
        if ($fixedPriceValueField.length) {
          if (chooseFixedPrice) {
            var randomFixedPrice = Math.floor(Math.random() * (9999 - 100 + 1)) + 100;
            $fixedPriceValueField.val(randomFixedPrice);
          } else {
            $fixedPriceValueField.val('');
          }
          fieldChanged($, $fixedPriceValueField.get(0));
        }

        redrawForm($);
    });

    $('.add_another_primary_contact').on('click', function(e) {
        e.preventDefault();
        $(".field-group-secondary_contact").show();
        $('.add_another_primary_contact').hide();
      }
    );

    $('.remove_secondary_contact').on('click', function(e) {
        e.preventDefault();
        // clear the fields
        $('.field-group-secondary_contact .sub_field').find('input, select, textarea').each(function(index, element) {
          $(element).val('');
        });
        $(".field-group-secondary_contact").hide();
        $('.add_another_primary_contact').show();
      }
    );

    recalcImageCount($);

  }

}

function initMobileExhibitionFormSelects($) {
  if (!window.matchMedia || !window.matchMedia('(max-width: 575.98px)').matches) {
    return;
  }

  var $form = $('.exhibition_submission_form');
  if ($form.length === 0) {
    return;
  }

  $form.find('select').each(function() {
    var $select = $(this);
    if ($select.data('mobileDropdownInit')) {
      return;
    }
    $select.data('mobileDropdownInit', true);

    var selectId = $select.attr('id') || '';
    var $wrapper = $('<div class="nets-select" data-select-id="' + selectId + '"></div>');
    var $trigger = $('<button type="button" class="nets-select__trigger" aria-haspopup="listbox" aria-expanded="false"></button>');
    var $list = $('<div class="nets-select__list" role="listbox"></div>');

    $wrapper.append($trigger, $list);
    $select.after($wrapper);

    function updateTrigger() {
      var text = $select.find('option:selected').text() || $select.find('option').first().text();
      $trigger.text(text);
    }

    function renderOptions() {
      $list.empty();
      $select.find('option').each(function() {
        var $option = $(this);
        var value = $option.attr('value') || '';
        var text = $option.text();
        var $item = $('<button type="button" class="nets-select__option" role="option"></button>');
        $item.text(text);
        $item.attr('data-value', value);
        if ($option.is(':selected')) {
          $item.addClass('is-selected');
        }
        $list.append($item);
      });
      updateTrigger();
    }

    renderOptions();

    $trigger.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = $wrapper.hasClass('is-open');
      $('.nets-select.is-open').removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
      $wrapper.toggleClass('is-open', !isOpen);
      $trigger.attr('aria-expanded', String(!isOpen));
    });

    $list.on('click', '.nets-select__option', function() {
      var value = $(this).attr('data-value');
      $select.val(value);
      $select.trigger('change');
      renderOptions();
      $wrapper.removeClass('is-open');
      $trigger.attr('aria-expanded', 'false');
    });

    $select.on('change.mobileSelect', function() {
      renderOptions();
    });
  });

  $(document).off('click.netsSelectExhibitionForm').on('click.netsSelectExhibitionForm', function() {
    $('.nets-select.is-open').removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
  });
}

function fieldChanged($, field) {
  // remove validation error class from parent
  $(field).closest('.form-field-group').removeClass('validation_error');
  $(field).closest('.sub_field').removeClass('validation_error');
  restoreFieldGroupValidationMessage($, $(field));

  // if no validation errors on this page then remove validation error from nav link
  var $currentPage = $(field).closest('.form_page');
  var pageId = $currentPage.attr('id');
  var nav_link_selector = '#form_navigator_link_' + pageId;

  var pageHasErrors = false;
  $currentPage.find('.form-field-group.validation_error, .sub_field.validation_error').each(function(index, element) {
    pageHasErrors = true;
  });

  if (!pageHasErrors) {
    $(nav_link_selector).removeClass('validation_error');
  }
}

function resetNavigatorErrorsForScope($, $parent) {
  var $pages = $parent.hasClass('form_page') ? $parent : $parent.find('.form_page');

  $pages.each(function(index, page) {
    var pageId = $(page).attr('id');

    if (pageId) {
      $('#form_navigator_link_' + pageId).removeClass('validation_error');
    }
  });
}

function validate_url(string) {
  let url;
  
  // returns true if string is a valid URL

  try {
    url = new URL(string);
  } catch (_) {
    return false;  
  }
  return url.protocol === "http:" || url.protocol === "https:";
}

function getMonthYearValue($parent, prefix) {
  var $month = $parent.find('select[name="' + prefix + '_month"]').first();
  var $year = $parent.find('select[name="' + prefix + '_year"]').first();

  if ($month.length === 0 || $year.length === 0) {
    return null;
  }

  var month = parseInt($month.val(), 10);
  var year = parseInt($year.val(), 10);

  if (!month || !year) {
    return null;
  }

  return year * 100 + month;
}

function setFieldGroupValidationMessage($, $field, message) {
  var $validationMessage = $field.closest('.form-field-group').find('.validation-message').first();

  if ($validationMessage.length === 0) {
    return;
  }

  if (!$validationMessage.data('default-validation-message')) {
    $validationMessage.data('default-validation-message', $validationMessage.text());
  }

  $validationMessage.text(message);
}

function restoreFieldGroupValidationMessage($, $field) {
  var $validationMessage = $field.closest('.form-field-group').find('.validation-message').first();
  var defaultMessage = $validationMessage.data('default-validation-message');

  if ($validationMessage.length > 0 && defaultMessage) {
    $validationMessage.text(defaultMessage);
  }
}

function setSubmitLoadingState($, isLoading) {
  var $submitButton = $('.form_page.active .button-submit-application').first();

  if ($submitButton.length === 0) {
    $submitButton = $('.button-submit-application:visible').first();
  }

  if ($submitButton.length === 0) {
    return;
  }

  var $spinner = $submitButton.siblings('.submit-spinner').first();

  if ($spinner.length === 0) {
    $spinner = $('<span class="submit-spinner" aria-hidden="true"></span>');
    $submitButton.before($spinner);
  }

  if (isLoading) {
    $submitButton.prop('disabled', true).addClass('is-loading').attr('aria-busy', 'true');
    $spinner.addClass('is-visible');
  } else {
    $submitButton.prop('disabled', false).removeClass('is-loading').removeAttr('aria-busy');
    $spinner.removeClass('is-visible');
  }
}

function submitExhibitionForm($) {
  if ($('.button-submit-application.is-loading').length > 0) {
    return;
  }

  $("input[name='exhibition_submission_form_submission_attempted']").val(1);

  var submissionValidated = validateExhibitionForm($('.exhibition_submission_form'));

  if (submissionValidated) {
    setSubmitLoadingState($, true);
  //  $('.exhibition_submission_form')[0].submit();
    $('.exhibition_submission_form').off('submit');    
    // submit form data to AJAX endpoint submit_exhibition_form

    var formdata = new FormData($('.exhibition_submission_form')[0]);

    // remove any fields beginning with 'required_'
    for (var pair of formdata.entries()) {
      if (pair[0].startsWith('required_')) {
        formdata.delete(pair[0]);
      }
    }

    formdata.append('action', 'submit_exhibition_form');

    ajaxurl = window.ajaxurl || '/wp-admin/admin-ajax.php';
    
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: formdata,
      processData: false,
      contentType: false,
      success: function(response) {
        // redirect to thank you page
        if (response.data.redirect_url) {
          window.location.href = response.data.redirect_url;
        }
      },
      error: function(xhr, status, error) {
        setSubmitLoadingState($, false);
        var errorMessage = 'An error occurred while submitting the form. Please try again.';
        
        // Check if response contains error message
        try {
          var response = JSON.parse(xhr.responseText);
          if (response.data && response.data.message) {
            errorMessage = response.data.message;
          }
        } catch (e) {
          // Failed to parse, use default message
        }
        
        // Show error message to user
        alert(errorMessage);
        console.log('Error submitting form');
        console.log(error);
      }
    });

    
  } else {
    console.log('Form validation failed, not submitting');
  }

}

function validateCurrentPage($) {
  var $currentPage = $('.form_page.active');
  if ($currentPage.length === 0) {
    return true; // no active pages, allow activation
  }

  return validateExhibitionForm($currentPage);
}

function validateExhibitionForm($parent) {
  $ = jQuery;

  
  var valid_form = true;
  syncWysiwygEditors();

  var submission_attempted = $("input[name='exhibition_submission_form_submission_attempted']").val();
  // loop through the form fields

  resetNavigatorErrorsForScope($, $parent);
  var focusedFirst = false;
  var firstInvalidPageId = null;
  var firstInvalidFieldName = null;
  $parent.find(':input').each(function(e, f){
      //your code here
      if ($(f).hasClass('validate')) {
        
        var invalid_field = false;
        var $val = $(f).val();

        // console.log('Validating field ' + $(f).attr('name') + ' with value ' + $val);

        // Only validate required fields if submission attempted
        var validation_required = submission_attempted && $(f).hasClass('validation_required');

        var validation_url = $(f).hasClass('validation_url');

        var validation_email = $(f).hasClass('validation_email');

        if (($(f).attr('name') == 'exhibition_details_price_fixed_price_value')) {
          if (!$('#exhibition_details_price_price_fixed').is(':checked')) {
            return;
          }
        }

        if (($(f).attr('name').includes('contacts_secondary_contact'))) {
          if (!$(f).is(':visible')) {
            return;
          }
        }

        if (validation_required) {
            invalid_field = ($val === '' || $val === null || $val == 0);
        }
        if (validation_url) {
          if ($val.length > 0) {
            invalid_field = !validate_url($val);
          }
        }
        if (validation_email) {
          var email_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if ($val.length > 0) {
            invalid_field = !email_regex.test($val);
          }
        }

        if (invalid_field) {
          var invalidPageId = $(f).closest('.form_page').attr('id');
          if (!firstInvalidPageId) {
            firstInvalidPageId = invalidPageId;
            firstInvalidFieldName = $(f).attr('name');
          }
          var nav_link_selector = '#form_navigator_link_' + invalidPageId;

          // add validation error class to nav link
          $(nav_link_selector).addClass('validation_error');

          // attach  class to parent li.form-field-group
          if ($(f).closest('.sub_field').length > 0) {
            $(f).closest('.sub_field').addClass('validation_error validation_error_subfield_' + $(f).attr('name'));
          } else {
            $(f).closest('.form-field-group').addClass('validation_error validation_error_field-group_' + $(f).attr('name'));
          }
          
          // focus the field
          // if (!focusedFirst) {
          //   $(f).focus();
          //   focusedFirst = true;
          // }
        }
        valid_form = valid_form && !invalid_field;
      }
      // attach change event to remove validation error class
      $(f).on('keyup change', function() {
        fieldChanged($, f);
      });
  });

  if (submission_attempted) {
    $required_group = $parent.find('input[name="required_group[]"]');
    $required_group.each(function(index, element) {
      var group_name = $(element).val();
      
      if (group_name == 'exhibition_details_price_fixed_price_freight'  ) {
        // if exhibition_details_price_price_fixed is not checked
        if (!$('#exhibition_details_price_price_fixed').is(':checked')) {
          return;
        }
      }

      var $field = $parent.find('input[name="' + group_name + '[]"]');
        
      var $checked = $parent.find('input[name="' + group_name + '[]"]:checked');
      if ($checked.length === 0) {
        valid_form = valid_form && false;

          // add validation error to all fields in the group
          $parent.find('input[name="' + group_name + '[]"]').each(function(i, f) {
    
          if ($(f).closest('.sub_field').length > 0) {
            $(f).closest('.sub_field').addClass('validation_error validation_error_subfield_' + $(f).attr('name'));
          } else {
            $(f).closest('.form-field-group').addClass('validation_error validation_error_field-group_' + $(f).attr('name'));
          }

          var invalidPageId = $(f).closest('.form_page').attr('id');
          if (invalidPageId) {
            var nav_link_selector = '#form_navigator_link_' + invalidPageId;
            $(nav_link_selector).addClass('validation_error');
          }
          if (!firstInvalidPageId) {
            firstInvalidPageId = invalidPageId;
            firstInvalidFieldName = $(f).attr('name');
          }
        });
        $field.on('change', function() {
          fieldChanged($, this);
        });
      }
    });

    if ($('#exhibition_details_price_price_fixed').is(':checked')) {
      var $fixedPriceField = $parent.find('input[name="exhibition_details_price_fixed_price_value"], input[name="exhibition_details_price_fixed_price_value[]"]').first();
      var fixedPriceValue = ($fixedPriceField.val() || '').toString().trim();

      if ($fixedPriceField.length > 0 && fixedPriceValue === '') {
        valid_form = false;

        if ($fixedPriceField.closest('.sub_field').length > 0) {
          $fixedPriceField.closest('.sub_field').addClass('validation_error validation_error_subfield_' + $fixedPriceField.attr('name'));
        } else {
          $fixedPriceField.closest('.form-field-group').addClass('validation_error validation_error_field-group_' + $fixedPriceField.attr('name'));
        }

        var fixedPriceInvalidPageId = $fixedPriceField.closest('.form_page').attr('id');
        if (fixedPriceInvalidPageId) {
          $('#form_navigator_link_' + fixedPriceInvalidPageId).addClass('validation_error');
        }

        if (!firstInvalidPageId) {
          firstInvalidPageId = fixedPriceInvalidPageId;
          firstInvalidFieldName = $fixedPriceField.attr('name');
        }
      }
    }

    var availableFromValue = getMonthYearValue($parent, 'exhibition_details_date_from');
    var availableToValue = getMonthYearValue($parent, 'exhibition_details_date_to');

    if (availableFromValue && availableToValue && availableToValue <= availableFromValue) {
      valid_form = false;

      var $availableToMonth = $parent.find('select[name="exhibition_details_date_to_month"]').first();
      var $availableToYear = $parent.find('select[name="exhibition_details_date_to_year"]').first();
      var $availableToField = $availableToMonth.length > 0 ? $availableToMonth : $availableToYear;

      $availableToField.closest('.form-field-group').addClass('validation_error validation_error_field-group_exhibition_details_date_to');
      setFieldGroupValidationMessage($, $availableToField, 'Available To must be after Available From.');

      var availableToInvalidPageId = $availableToField.closest('.form_page').attr('id');
      if (availableToInvalidPageId) {
        $('#form_navigator_link_' + availableToInvalidPageId).addClass('validation_error');
      }

      if (!firstInvalidPageId) {
        firstInvalidPageId = availableToInvalidPageId;
        firstInvalidFieldName = $availableToField.attr('name');
      }
    }
  }

  // Validate that at least 1 image or video is submitted - only if we're on the image gallery page
  if (submission_attempted) {
    var $imageFormHolder = $parent.find('.exhibition-image-form-holder');
    
    // Only validate image gallery if the image form holder exists on the current page
    if ($imageFormHolder.length > 0) {
      var hasImageOrVideo = false;
      for (var i = 1; i <= 10; i++) {
        var imageUploadName = 'work_' + i + '_exhibition_image_upload';
        var videoUrlName = 'work_' + i + '_video_url';
        var $imageInput = $parent.find('input[name="' + imageUploadName + '"]');
        var $videoInput = $parent.find('input[name="' + videoUrlName + '"]');
        
        var hasImage = $imageInput.length && $imageInput[0].files && $imageInput[0].files.length > 0;
        var hasVideo = $videoInput.length && $videoInput.val().trim() !== '';
        
        if (hasImage || hasVideo) {
          hasImageOrVideo = true;
          break;
        }
      }
      
      if (!hasImageOrVideo) {
        valid_form = false;
        var $parentFormFieldGroup = $imageFormHolder.closest('.form-field-group');
        if ($parentFormFieldGroup.length > 0) {
          $parentFormFieldGroup.addClass('validation_error validation_error_field-group_image_gallery');
        }
        
        // Find the page this form is on and mark it as having errors
        var imageGalleryPageId = $imageFormHolder.closest('.form_page').attr('id');
        if (imageGalleryPageId) {
          $('#form_navigator_link_' + imageGalleryPageId).addClass('validation_error');
          if (!firstInvalidPageId) {
            firstInvalidPageId = imageGalleryPageId;
            firstInvalidFieldName = 'image_gallery_validation';
          }
        }
      }
    }
  }

  if (firstInvalidPageId) {
    // activate the first invalid page
    activateSection($, firstInvalidPageId, true);
    // focus the first invalid field
    if (firstInvalidFieldName) {
      var $firstInvalidField = $parent.find('input[name="' + firstInvalidFieldName + '"], select[name="' + firstInvalidFieldName + '"], textarea[name="' + firstInvalidFieldName + '"]');

      if ($firstInvalidField.length > 0) {
        $firstInvalidField.focus();
        // scroll to field
        $('html, body').animate({
          scrollTop: $firstInvalidField.offset().top - 220
        }, 500);
      }
    }
  }
  

  return valid_form;
}

export default initAddExhibition;
